import { render } from "./UserAuditLogsTable.vue?vue&type=template&id=955ff766&scoped=true"
import script from "./UserAuditLogsTable.vue?vue&type=script&lang=js"
export * from "./UserAuditLogsTable.vue?vue&type=script&lang=js"

import "./UserAuditLogsTable.vue?vue&type=style&index=0&id=955ff766&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-955ff766"]])

export default __exports__